<mat-card-content class="card-body">
  <ng-content></ng-content>
</mat-card-content>

